import { useTranslation } from "react-i18next";
import { FormControl, FormLabel } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { EditEntityProfileData } from "../../../../../types/editEntityProfile-type";

const EstablishedYearField = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });
  const { control } = useFormContext<EditEntityProfileData>();

  return (
    <Controller
      name="foundedYear"
      control={control}
      render={({ field: { onChange, value, ...field }, fieldState: { error } }) => (
        <FormControl error={!!error} fullWidth>
          <FormLabel
            sx={{
              color: "var(--Dark---800, #414141)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "24px",
            }}
          >
            {t("establishedYear")}
          </FormLabel>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              {...field}
              value={value ? new Date(value, 0, 1) : null}
              onChange={(date) => onChange(date?.getFullYear())}
              views={["year"]}
              disableFuture
              slotProps={{
                textField: {
                  error: !!error,
                  helperText: error?.message && t(error.message),
                  placeholder: t("establishedYear"),
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      )}
    />
  );
};

export default EstablishedYearField;
